import LogoIcon from './LogoIcon';

export default LogoIcon;
